import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import { createApi } from '@reduxjs/toolkit/query/react'
import type { GetApplyV2SettingsResponse } from 'core/app/types/applyV2Type'

export const applyJobV2Api = createApi({
    reducerPath: 'applyJobV2Api',
    baseQuery: fetchBaseQuery({
        baseUrl:
            process.env.ENV === 'local'
                ? `${process.env.API_URL}/api/v2/apply`
                : `${window.location.origin}/api/v2/apply`,
        prepareHeaders: (headers) => {
            const token = document.getElementsByName('csrf-token')[0]?.getAttribute('content')
            if (token) headers.set('X-CSRF-TOKEN', token)

            const customCorporation = document.getElementById('__custom_route_data')?.getAttribute('data-corpId')
            if (customCorporation) headers.set('X-CORP-CONTEXT', customCorporation)

            headers.set('Response-V2', '1')
            return headers
        },
        credentials: process.env.ENV === 'local' ? 'include' : 'same-origin',
    }),
    tagTypes: ['applyJobV2'],
    endpoints: (builder) => ({
        getApplyV2SettingsById: builder.query<GetApplyV2SettingsResponse, { id?: number | string }>({
            query: ({ id }) => `settings/${id}`,
            providesTags: (result, error, { id }) => (id ? [{ type: 'applyJobV2', id }] : []),
        }),
        getApplyV2Profile: builder.query<any, { uid?: string }>({
            query: ({ uid }) => ({
                url: 'profile',
                params: { uid },
            }),
            providesTags: (result, error, { uid }) => (uid ? [{ type: 'applyJobV2', id: uid }] : []),
        }),
        initApplyV2: builder.mutation<any, { id: number | string; body?: any }>({
            query: ({ id, body }) => ({
                url: `init/${id}`,
                method: 'POST',
                body,
            }),
            // invalidatesTags: (result, error, { id }) => [{ type: 'applyJobV2', id }],
        }),
    }),
})

export const { useGetApplyV2SettingsByIdQuery, useGetApplyV2ProfileQuery, useInitApplyV2Mutation } = applyJobV2Api
